<template>
    <div>
        <v-container>
            <v-layout>
                <v-flex xs12 style="text-align: center">{{ $t("monitoring.anas.voucherAttached", { count: conversions.vouchers }) }}</v-flex>
            </v-layout>
            <v-layout>
                <v-flex xs6 style="text-align: center">{{ $t("monitoring.anas.idReminderConversion", { percent: conversions.id_reminder.activated }) }}</v-flex>
                <v-flex xs6 style="text-align: center">{{ $t("monitoring.anas.idReminderTotal", { count: conversions.id_reminder.reminded }) }}</v-flex>
            </v-layout>
        </v-container>
        <loading-component :value="loading"></loading-component>
        <DataTable
                ref="dataTable"
                :title="$t('monitoring.anas.anasStats')"
                :url="api.ACTIONS.ANAS"
                :enable-edit="false"
                :enable-delete="false"
                :enable-add="false"/>
    </div>
</template>

<script>
    import DataTable from '@/components/monaco/DataTable';
    import LoadingComponent from "@/components/LoadingComponent";

    export default {
        name: "FirstRidePax",
        title() {
            return this.$t("monitoring.anas.title");
        },
        components: {LoadingComponent, DataTable},
        data() {
            return {
                loading: false,
                conversions: {
                    id_reminder: {}
                }
            }
        },
        mounted() {
            this.axios.get('customer_care/anas_conversions')
                .then(res => this.conversions = res.data.data)
                .catch(err => console.log(err.message));
        }
    }
</script>

<style scoped>

</style>